import React, { useEffect } from 'react';
import { IPaymentGatewayItemProps, PaymentGatewayTableRow } from './PaymentGatewayTableRow';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Spinner } from '../../Spinner';
import { usePaymentContext } from '../../../store/payments/payments-context';
import {
	fetchPaymentGatewayData,
	fetchProviderLists,
	setPaymentGateway,
} from '../../../store/payments/actions/providers';

const column = [
	{
		key: 'bars',
		title: ''
	},
	{
		key: 'order',
		title: 'PAYMENTS_GATEWAY.ORDER'
	},
	{
		key: 'action',
		title: 'PAYMENTS_GATEWAY.ACTION'
	},
	{
		key: 'processor',
		title: 'PAYMENTS_GATEWAY.GATEWAY_NAME'
	},
	{
		key: 'mcc',
		title: 'PAYMENTS_GATEWAY.MCC'
	},
	{
		key: 'processorId',
		title: 'PAYMENTS_GATEWAY.PROCESSOR_ID'
	},
	{
		key: 'masterCard_MonthlyMaxTransactionsCount',
		title: 'PAYMENTS_GATEWAY.MC_MONTHLY_MAX_TRANSACTIONS_COUNT'
	},
	{
		key: 'masterCard_MonthlyMaxValue',
		title: 'PAYMENTS_GATEWAY.MC_MONTHLY_MAX_VALUE'
	},
	{
		key: 'cardBrand',
		title: 'PAYMENTS_GATEWAY.CARD_BRAND'
	},
	{
		key: 'supportMit',
		title: 'PAYMENTS_GATEWAY.MIT_SUPPORT'
	},
	{
		key: 'supportCit',
		title: 'PAYMENTS_GATEWAY.CIT_SUPPORT'
	},
	{
		key: 'sandbox',
		title: 'PAYMENTS_GATEWAY.SANDBOX'
	},

	{
		key: 'active',
		title: 'PAYMENTS_GATEWAY.ACTIVE'
	},
	{
		key: 'default',
		title: 'PAYMENTS_GATEWAY.DEFAULT'
	}
];

interface Props {
	paymentActiveStatus: string | null;
	setPaymentActiveStatus: (status: string | null) => void;
}

export const PaymentGatewayTable = ({ paymentActiveStatus, setPaymentActiveStatus }: Props): JSX.Element => {
	const { id: merchantId } = useParams<{ id: string }>();
	const { paymentContextState, dispatch } = usePaymentContext();
	const {
		paymentGatewayData,
		isPaymentGatewayDataLoading
	} = paymentContextState;
	// const [paymentGateways, setPaymentGateways] = useState<IPaymentProps[]>(paymentGatewayData);
	const { t } = useTranslation();

	// useEffect(() => {
	// 	console.log('paymentGatewayData', paymentGatewayData);
	// 	setPaymentGateways(paymentGatewayData);
	// }, [paymentGatewayData]);

	const getTableData = (): IPaymentGatewayItemProps[] => {
		switch (paymentActiveStatus) {
			case '1':
				return paymentGatewayData?.filter((item) => item.isActive);
			case '2':
				return paymentGatewayData?.filter((item) => !item.isActive);
			default:
				return paymentGatewayData;
		}
	};

	useEffect(() => {
		if (paymentActiveStatus === '1' && paymentGatewayData?.length && !getTableData().length) {
			setPaymentActiveStatus(null);
		}
	}, [paymentGatewayData, paymentActiveStatus]);

	useEffect(() => {
		void fetchProviderLists({ dispatch, providerName: 'nmi' });
	}, []);

	const handleDragEnd = async (results): Promise<void> => {
		const tempGateways = [...paymentGatewayData];
		const selectedRow = tempGateways.splice(results.source.index, 1);
		tempGateways.splice(results.destination.index, 0 , selectedRow[0]);
		const params = {
			...selectedRow[0],
			order: results.destination.index
		};
		// setPaymentGateways(tempGateways);
		await setPaymentGateway(params);
		await fetchPaymentGatewayData({ dispatch, mid: merchantId });
	};

	const getTableHeader = (): React.ReactElement[] => (
		column.map(col => (
			<th key={col.key}>
				<div className="d-flex align-items-center fs-8">
					{t(col.title)}
				</div>
			</th>
		))
	);

	if (isPaymentGatewayDataLoading) {
		return (
			<div className="h-200px">
				<Spinner pageLoader />
			</div>
		);
	}

	console.log('paymentGatewayData', paymentGatewayData);

	return (
		<div className="table-responsive table-min-height position-relative">
			{/* eslint-disable-next-line @typescript-eslint/explicit-function-return-type */}
			<DragDropContext onDragEnd={(results) => handleDragEnd(results)}>
				<table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
					<thead>
						<tr className="fw-bolder text-muted">
							{getTableHeader()}
						</tr>
					</thead>
					<Droppable droppableId="tbody">
						{/* eslint-disable-next-line @typescript-eslint/explicit-function-return-type */}
						{(provider) => (
							<tbody ref={provider.innerRef} {...provider.droppableProps}>
								{getTableData().map((elementProps, index) => (
										<PaymentGatewayTableRow
											{...elementProps}
											key={elementProps.id}
											index={index}
										/>
									))
								}
							</tbody>
						)}
					</Droppable>
				</table>
			</DragDropContext>
		</div>
	);
};
